import React, { Component } from 'react';

import SidebarComponent from '../components/SidebarComponent';
import NavbarComponent from '../components/NavbarComponent';
import HeaderComponent from '../components/HeaderComponent';
import TableDiscountCodesComponent from '../components/TableDiscountCodesComponent';
import { validateSession } from  '../utils/functions';
import { navigateTo } from '../utils/navigation';

class DiscountCodesPage extends Component {

	constructor(){
        const cachedRole = Number(localStorage.getItem('role') || 0);
        super();
        this.state = {
            checked: !!localStorage.getItem('token'),
            role: cachedRole
        }
	}

	async componentDidMount() {
        let role = await validateSession(true)
        this.setState({ checked: true, role: role });
    }

    addDiscountCode = () => {
        navigateTo('/addDiscountCode');
    }
    
	render() {
        if (!this.state.checked) {
            return (<div></div>);
        } else {
            return (  
                <div class="container-fluid">
                    <div class="row">
                        <SidebarComponent itemSelected={11} role={this.state.role}/>
                        <main class="main-content col-lg-10 col-md-9 col-sm-12 p-0 offset-lg-2 offset-md-3">
                            <NavbarComponent role={this.state.role} />
                            <div className="main-content-container container-fluid px-4 mb-4">
                                <HeaderComponent title="Compras" subtitle="Códigos de descuento"/>
                                <TableDiscountCodesComponent />
                            </div>
                        </main>
                    </div>

                    <div onClick={() => this.addDiscountCode()} class="color-switcher-toggle animated pulse infinite">
                        <i class="material-icons">add</i>
                    </div>
                </div>
            );
        }
    }
}

export default DiscountCodesPage;
